/** Fleury Impuls quantity controls. Horizon owns the cart; fa-floetrol owns pricing. */
function initPinselreinigerPurchase(root) {
  if (root.dataset.faPurchaseReady === 'true') return;
  const input = root.querySelector('[data-fa-main-quantity]');
  const component = root.querySelector('[data-fa-main-form]');
  const sticky = root.querySelector('[data-fa-sticky]');
  const stickyButton = root.querySelector('[data-fa-sticky-add]');
  const error = root.querySelector('[data-fa-quantity-error]');
  const controls = [...root.querySelectorAll('[data-fa-quantity-step]')];
  let config;
  try { config = JSON.parse(root.querySelector('[data-fa-floetrol-config]').textContent); }
  catch { return; }
  if (!input || !component || !error || controls.length !== 2) return;
  let touched = false;
  function sync() {
    const busy = component.getAttribute('aria-busy') === 'true';
    const valid = input.validity.valid;
    const value = Number(input.value);
    const minimum = Number(input.min || 1);
    const maximum = input.max ? Number(input.max) : Infinity;
    input.readOnly = busy;
    if (stickyButton) {
      stickyButton.disabled = input.disabled || busy;
      stickyButton.setAttribute('aria-busy', String(busy));
    }
    controls.forEach(button => {
      button.disabled = input.disabled || busy || (valid && (button.dataset.faQuantityStep === 'down' ? value <= minimum : value >= maximum));
    });
    root.querySelectorAll('[data-fa-quantity-count]').forEach(node => {
      node.textContent = valid ? (value === 1 ? config.labels.quantitySingle : config.labels.quantityMany.replace('{quantity}', String(value))) : '—';
    });
    if (!valid) root.querySelectorAll('[data-fa-total]').forEach(node => { node.textContent = '—'; });
    error.hidden = valid || !touched;
    error.textContent = error.hidden ? '' : config.labels.quantityError;
    if (touched) input.setAttribute('aria-invalid', String(!valid));
  }
  controls.forEach(button => {
    button.hidden = false;
    button.addEventListener('click', () => {
      if (button.disabled) return;
      touched = true;
      if (!input.validity.valid) input.value = input.min || '1';
      else if (button.dataset.faQuantityStep === 'up') input.stepUp();
      else input.stepDown();
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });
  input.addEventListener('input', sync);
  input.addEventListener('change', () => { touched = true; sync(); });
  input.addEventListener('blur', () => { touched = true; sync(); });
  // Let native form validation report invalid submissions without changing cart handling.
  input.addEventListener('invalid', () => { touched = true; input.setAttribute('aria-invalid', 'true'); error.hidden = false; error.textContent = config.labels.quantityError; });
  new MutationObserver(sync).observe(component, { attributes: true, attributeFilter: ['aria-busy'] });
  // Keep the mobile purchase controls clear of the site's floating shortcuts.
  const purchaseZone = root.querySelector('.fa-pinselreiniger-buy-zone');
  if (purchaseZone && 'IntersectionObserver' in window) {
    new IntersectionObserver(([entry]) => {
      root.toggleAttribute('data-fa-purchase-visible', entry.isIntersecting);
    }).observe(purchaseZone);
  }
  if (sticky && 'ResizeObserver' in window) {
    new ResizeObserver(() => {
      const height = sticky.getBoundingClientRect().height;
      if (height > 0) document.documentElement.style.setProperty('--fa-pinselreiniger-sticky-height', `${Math.ceil(height)}px`);
    }).observe(sticky);
  }
  sync();
  root.dataset.faPurchaseReady = 'true';
}
const startPinselreinigerPurchase = () => document.querySelectorAll('.fa-pinselreiniger[data-fa-floetrol]').forEach(initPinselreinigerPurchase);
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', startPinselreinigerPurchase, { once: true });
else startPinselreinigerPurchase();
document.addEventListener('shopify:section:load', startPinselreinigerPurchase);
